import s from "./Reviews.module.scss";
import st from "@/styles/modules/typography.module.scss";
import cn from "classnames";
import Image from "next/legacy/image";
import { Score } from "@/components/UI/Score";

type ReviewsProps = {
  className?: string;
};

const reviews = [
  {
    name: "StudyBounty",
    icon: "/img/logo-alt.svg",
    rating: 4.9,
  },
  {
    name: "Sitejabber",
    icon: "/img/reviews/sitejabber.svg",
    rating: 4.8,
  },
  {
    name: "Trustpilot",
    icon: "/img/reviews/trustpilot.svg",
    rating: 4.7,
  },
  {
    name: "Reviews.io",
    icon: "/img/reviews/reviews-io.svg",
    rating: 4.8,
  },
];
export const Reviews = ({ className }: ReviewsProps) => (
  <ul className={cn(st.card, s.card, className)}>
    {reviews.map(({ name, icon, rating }, index) => (
      <li key={index}>
        <Image src={icon} alt={name} width={40} height={40} />
        <div className={s.main}>
          <div className={s.name}>{name}</div>
          <Score score={rating} size="big" />
        </div>
      </li>
    ))}
  </ul>
);
